import { Car } from 'lucide-react';
import { cn } from '@bia-auction/ui';
import { MediaImg } from './MediaImg';

/**
 * Cover thumbnail for a vehicle, with a deliberate placeholder rather than an empty box: a
 * blank grey rectangle in a list of cars reads as a broken image, not as "no photo yet".
 *
 * There is **no thumbnail variant** to ask for — only browser uploads produce a 375px copy and
 * mirrored photos are stored as fetched (ADR 0025) — so sizing is CSS + `object-cover`, never
 * a `-tn` URL.
 */
export function VehicleThumb({
  url,
  plate,
  className,
}: {
  url?: string | null;
  plate?: string | null;
  className?: string;
}) {
  const base = 'shrink-0 overflow-hidden rounded-md border bg-muted';
  if (!url) {
    return (
      <div
        className={cn(base, 'flex items-center justify-center text-muted-foreground', className)}
        aria-hidden
      >
        <Car className="h-4 w-4" />
      </div>
    );
  }
  // Through `MediaImg`, which recovers from an expired access token — this thumbnail is `lazy`, so
  // it is one of the elements that loads long after the page (and its token) did (ADR 0027).
  return (
    <MediaImg
      path={url}
      alt={plate ?? ''}
      loading="lazy"
      className={cn(base, 'object-cover', className)}
    />
  );
}
